import { useContext } from 'react';
import Tabs from '../components/Tabs';
import {
  excludedProductListForPermissableProducts,
  productNameToExclude,
} from '../constant/constant';
import {
  ListMedicationsProps,
  ProductFormulation,
  ProductTypes,
  TabItem,
} from '../interface/interface';
import { ListMedications } from './ListMedications';
import NonScriptRange from './NonScriptRange';
import { UserContext } from '../context/userContext';

export const PatientOrderTab = ({
  products,
  addProductToCart,
  removeProductFromCart,
  nonOrderable,
  isHome,
  wishListProducts,
}: ListMedicationsProps) => {
  const { isMobile } = useContext(UserContext);
  const tabs: Array<TabItem> = [
    {
      id: '1',
      label: 'Treatment Plan',
      component: (
        <ListMedications
          products={products?.filter(
            (product) =>
              (![ProductFormulation.TEST_KIT].includes(
                product?.productFormulation?.name,
              ) &&
                !product?.isAllowed &&
                product.is_shop_product) ||
              excludedProductListForPermissableProducts.includes(product.name),
          )}
          addProductToCart={addProductToCart}
          removeProductFromCart={removeProductFromCart}
          nonOrderable={nonOrderable?.filter(
            (product) =>
              !(
                [ProductTypes.ACCESSORIES, ProductTypes.DEVICE] as string[]
              ).includes(product?.product_type) &&
              !productNameToExclude.includes(product.name),
          )}
          isHome={isHome}
          wishListProducts={wishListProducts}
        />
      ),
    },
    {
      id: '2',
      label: 'Accessories',
      component: (
        <ListMedications
          products={products?.filter((product) => {
            const hasDrugKits =
              product?.productFormulation?.name?.trim() ===
              ProductFormulation.TEST_KIT;

            const isAllowed = product?.isAllowed === true;

            const nonShopProduct = product.is_shop_product === false;

            const hasPrimaryAccessory =
              excludedProductListForPermissableProducts.includes(product.name);

            return (
              (hasDrugKits || isAllowed || nonShopProduct) &&
              !hasPrimaryAccessory
            );
          })}
          isHome={isHome}
          addProductToCart={addProductToCart}
          removeProductFromCart={removeProductFromCart}
          nonOrderable={nonOrderable?.filter((product) => {
            const isMatchingType = [
              ProductTypes.ACCESSORIES,
              ProductTypes.DEVICE,
            ].includes(product?.product_type as ProductTypes);
            const isNotInProductArray = !products?.some(
              (p) => p.id === product.id,
            );
            const isAllowed = !products?.some((p) => p.id === p?.isAllowed);
            return isMatchingType && isNotInProductArray && isAllowed;
          })}
          wishListProducts={wishListProducts}
        />
      ),
    },
    {
      id: '3',
      label: 'Shop Non-Script',
      component: <NonScriptRange />,
    },
  ];

  const tabData = sessionStorage.getItem('homeTab');
  let activeTab: string | undefined;
  if (tabData) {
    activeTab = tabs[Number(tabData) - 1].label;
  }

  return (
    <div className="container-standard">
      <Tabs
        tabs={
          isMobile
            ? tabs.filter((tab) => tab.label !== 'Shop Non-Script')
            : tabs
        }
        activeTabLabel={activeTab}
        isHome={isHome}
      />
    </div>
  );
};
